import { Component, HostBinding, inject, Input } from '@angular/core';
import { OnderwijsresultatenRow } from '../card-or-cell/card-or-cell.component';
import { DashboardVariant } from '../../../services/weergave-opties';
import { QueryParamStateService } from '../../../services/query-param-state.service';
import { ExtendedDecimalPipe } from '@cumlaude/shared-pipes';
import { PercentPipe } from '@angular/common';
import { LinechartComponent } from '../../../shared/dashboard/linechart-table/linechart/linechart.component';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-card-or-row-cell',
	templateUrl: './card-or-row-cell.component.html',
	styleUrls: ['./card-or-row-cell.component.scss'],
	imports: [LinechartComponent, PercentPipe, ExtendedDecimalPipe, IconComponent],
})
export class CardOrRowCellComponent {
	readonly qp = inject(QueryParamStateService);

	@Input()
	row!: OnderwijsresultatenRow;

	@Input()
	variant!: DashboardVariant;

	toonTrend = this.qp.signal('toon-trend');

	@HostBinding('class.card-cell-column')
	get columnClass(): boolean {
		return this.variant === DashboardVariant.ACTUEEL;
	}

	@HostBinding('class.percent')
	get percentClass(): boolean {
		return this.row.indicator === 'bbs';
	}

	@HostBinding('class.decimal')
	get decimalClass(): boolean {
		return this.row.indicator === 'exc';
	}

	@HostBinding('class.card-cell-row')
	get rowClass(): boolean {
		return this.variant === DashboardVariant.HISTORIE;
	}

	protected readonly DashboardVariant = DashboardVariant;
}
